<template>
  <component :is="this.pageType" />
</template>

<script>
import MobileApps from './MobileApps'
import MaterialLimits from './MaterialLimits'
import ProjectLimits from './ProjectLimits'
import ProjectGeodesists from './ProjectGeodesists'
import WorkSetCheckGroupSchema from './WorkSetCheckGroupSchema'

export default {
  name: "Handbook",
  components: {
    MobileApps,
    'material-limits': MaterialLimits,
    'project-limits': ProjectLimits,
    'project-geodesists': ProjectGeodesists,
    'work-set-check-group-schema': WorkSetCheckGroupSchema,
  },
  computed: {
    pageType() {
      return this.$route.params?.type
    }
  },
}
</script>
